var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 256 256",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.716 25.955C57.6242 25.955 60.1205 23.4628 60.1205 20.5505C60.1205 17.6382 57.6284 15.1461 54.716 15.1461C51.8037 15.1461 49.3075 17.6382 49.3075 20.5505C49.7234 23.4587 51.8036 25.955 54.716 25.955Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.673 82.9159C153.673 85.8241 156.165 88.3203 159.073 88.3203C161.985 88.3203 164.482 85.8282 164.482 82.9159C164.482 80.0036 161.989 77.5114 159.073 77.5114C156.165 77.5114 153.673 80.0036 153.673 82.9159Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.689 218.044L39.3307 218.044C33.5102 218.044 28.9378 222.616 28.9378 228.436C28.9378 234.257 33.5102 238.829 39.3307 238.829L106.689 238.829C112.509 238.829 117.081 234.257 117.081 228.436C117.081 222.616 112.509 218.044 106.689 218.044Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.689 192.265L39.3307 192.265C33.5102 192.265 28.9378 196.838 28.9378 202.658C28.9378 208.479 33.5102 213.051 39.3307 213.051L106.689 213.051C112.509 213.051 117.081 208.479 117.081 202.658C117.081 196.838 112.509 192.265 106.689 192.265Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.689 166.071L49.7234 166.071L39.3305 166.071C33.51 166.071 28.9377 170.643 28.9377 176.464C28.9377 182.284 33.51 186.857 39.3305 186.857L106.688 186.857C112.509 186.857 117.081 182.284 117.081 176.464C117.081 170.643 112.509 166.071 106.689 166.071Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7234 134.888L96.7075 134.888C102.528 134.888 107.104 130.316 107.104 124.495C107.104 118.675 102.532 114.103 96.7075 114.103L49.7234 114.103L28.9336 114.103C23.1172 114.103 18.5448 118.675 18.5448 124.495C18.5448 130.316 23.1172 134.888 28.9336 134.888L49.7234 134.888Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.081 140.293L96.2914 140.293L49.7234 140.293C43.9029 140.293 39.3305 144.865 39.3305 150.686C39.3305 156.506 43.9029 161.079 49.7234 161.079L106.684 161.079L117.077 161.079C122.898 161.079 127.47 156.506 127.47 150.686C127.474 144.865 122.902 140.293 117.081 140.293Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.733 72.523C206.889 72.523 210.633 69.1946 210.633 64.6223C210.633 60.0499 207.305 56.7216 202.733 56.7216C198.16 56.7216 194.832 60.0499 194.832 64.6223C194.832 69.1946 198.572 72.523 202.733 72.523Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.081 88.3203L101.284 88.3203L49.7234 88.3203C43.9029 88.3203 39.3305 92.8927 39.3305 98.7132C39.3305 104.534 43.9029 109.106 49.7234 109.106L96.7075 109.106L117.497 109.106C123.318 109.106 127.89 104.534 127.89 98.7132C127.894 92.8927 122.902 88.3203 117.081 88.3203Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9303 82.9159L49.7276 82.9159L101.7 82.9159C107.521 82.9159 112.093 78.3435 112.093 72.523C112.093 66.7025 107.104 62.1302 101.7 62.1302L33.9303 62.1302C28.1098 62.1302 23.5374 66.7025 23.5374 72.523C23.5374 78.3435 28.1056 82.9159 33.9303 82.9159Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.034 192.265L158.657 192.265L148.264 192.265C142.444 192.265 137.871 196.838 137.871 202.658C137.871 208.479 142.444 213.051 148.264 213.051L216.034 213.051C221.854 213.051 226.427 208.479 226.427 202.658C226.427 196.838 221.442 192.265 216.034 192.265Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.264 46.7448C154.084 46.7448 158.657 42.1724 158.657 36.3519C158.657 30.5314 154.084 25.9591 148.264 25.9591C142.443 25.9591 137.871 30.5314 137.871 36.3519C137.871 41.7522 142.444 46.7448 148.264 46.7448Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.431 166.071L158.661 166.071C152.84 166.071 148.268 170.643 148.268 176.464C148.268 182.284 152.84 186.857 158.661 186.857L216.038 186.857L226.431 186.857C232.251 186.857 236.824 182.284 236.824 176.464C236.824 170.643 231.835 166.071 226.431 166.071Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.034 218.044L148.264 218.044C142.444 218.044 137.871 222.616 137.871 228.436C137.871 234.257 142.444 238.829 148.264 238.829L216.034 238.829C221.854 238.829 226.427 234.257 226.427 228.436C226.427 222.616 221.442 218.044 216.034 218.044Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92 161.083C208.133 161.083 221.022 147.777 221.022 131.976C221.022 115.763 207.721 102.874 191.92 102.874C175.711 102.874 162.821 116.179 162.821 131.976C162.401 147.777 175.711 161.083 191.92 161.083ZM188.179 134.472C186.519 134.056 184.851 133.224 183.607 132.812C182.359 131.98 181.111 131.564 180.279 130.732C179.451 129.9 178.619 129.068 178.203 127.82C177.782 126.572 177.782 125.328 177.782 124.079C177.782 122.415 178.203 120.751 178.614 119.091C179.447 117.843 180.275 116.599 181.107 115.351C182.355 114.519 183.603 113.687 184.847 112.854C186.511 112.438 187.759 112.022 189.839 111.606L189.839 106.202L193.996 106.202L193.996 112.022C196.492 112.438 198.568 112.854 200.648 113.687C202.729 114.519 204.389 115.351 206.057 116.179L202.312 123.663C202.312 123.663 201.896 123.247 201.485 122.831C201.064 122.415 200.236 121.999 199.404 121.583C198.572 121.167 197.744 120.751 196.912 120.335C196.08 119.919 194.832 119.919 194 119.503L194 126.988L195.664 127.404C197.324 127.82 198.992 128.652 200.652 129.068C202.312 129.484 203.561 130.316 204.393 131.148C205.225 131.98 206.057 133.224 206.889 134.472C207.309 135.72 207.721 137.385 207.721 139.045C207.721 141.125 207.305 142.789 206.473 144.037C205.641 145.285 204.813 146.529 203.561 147.366C202.312 148.198 201.068 149.03 199.404 149.442C197.744 149.858 196.076 150.274 194.416 150.274L194.416 156.51L190.672 156.51L190.672 150.274C188.179 149.858 185.683 149.442 183.191 148.61C180.699 147.777 178.619 146.945 176.538 145.701L180.279 138.217C180.279 138.217 180.699 138.633 181.527 139.049C182.359 139.465 182.779 139.881 184.023 140.297C184.851 140.713 186.099 141.129 187.351 141.545C188.6 141.961 189.848 142.377 191.092 142.377L191.092 135.308L188.179 134.472Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.744 139.877C197.744 139.045 197.324 138.213 196.492 137.797C195.664 137.381 194.832 136.964 193.584 136.548L193.584 142.785C196.08 142.373 197.744 141.541 197.744 139.877Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M191.092 119.503C188.596 119.919 187.352 120.751 187.352 122.411C187.352 123.243 187.768 124.075 188.18 124.487C189.012 124.903 189.844 125.319 191.092 125.735L191.092 119.503L191.092 119.503Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokens);
export default __webpack_public_path__ + "static/media/tokens.6e3a1912a3bdbbedd4e5a6b899b81455.svg";
export { ForwardRef as ReactComponent };